import { parseISO, format } from "date-fns/esm";

import { DownloadDocument } from "./DownloadDocument";

export const transactionsColumns = [
  {
    dataField: "created_at",
    text: "Date",
    props: {
      cell: ({ getValue }) => {
        const value = getValue();
        return <span>{format(parseISO(value), "MM/dd/yyyy")}</span>;
      },
    },
  },
  {
    dataField: "type",
    text: "Type",
  },
  {
    dataField: "amount",
    text: "Amount",
  },
  {
    dataField: "status",
    text: "Status",
    props: {
      cell: ({ getValue }) => {
        const value = getValue();
        return <span className={value.toLowerCase()}>{value}</span>;
      },
    },
  },
];

export const accountDocumentsColumns = [
  {
    dataField: "date",
    text: "Date",
  },
  {
    dataField: "name",
    text: "Type",
  },
  {
    dataField: "id",
    text: "Download",
    props: {
      cell: ({ row }) => {
        return <DownloadDocument data={row.original} />;
      },
    },
  },
];
